import React from 'react';
import { Show, SimpleShowLayout, EditButton, RichTextField, ReferenceManyField, Datagrid, TextField, Pagination, useRefresh, usePermissions } from 'react-admin';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import LocationsIcon from '@material-ui/icons/Apartment';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';

const ContactShowActions = (props) => {
    const { basePath } = props;

    return (
        <CardActions>
            <BackButton style={{ marginRight: "auto" }}></BackButton>
            <EditButton basePath={basePath} record={props.data} />
        </CardActions>
    );
};

const ContactShowGeneral = ({ record }) => {
    const { display_name, email, phone } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row row-cols-2 row-cols-lg-2 g-2 g-lg-2 mb-2">
                    <div className="w-100">
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name </h6>
                        {display_name ? display_name.length > 0 ? <span className="fw-italic m-0 p-0">{display_name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Phone</h6>
                        {phone ? phone.length > 0 ? <span className="fw-italic text-lowercase">{phone}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Email</h6>
                        {email ? email.length > 0 ? <span className="fw-italic text-lowercase">{email}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 mb-3 m-o p-0">
                <ContactShowNotes record={record} />
            </div>
        </div>
    );
};

const ContactShowNotes = ({ record }) => {
    const { notes } = record;

    return (
        <div className="row h-100 w-100 m-0 p-0">
            <div>
                <h6 className="text-secondary" style={{ marginBottom: '10px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes</h6>
                <div className="p-2 pb-0 w-100 h-100" style={{ backgroundColor: 'rgb(255, 238, 201)', borderRadius: '0px 5px 5px 5px' }}>
                    {notes ? notes.length > 0 ? <RichTextField source="notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
};

const LocationSectionTitle = ({ record }) => {
    return (
        <div className="d-flex align-items-center">
            <h5 className="font-weight-normal pt-2">{<LocationsIcon className="d-inline text-danger" style={{ fontSize: '38px' }} />} Locations </h5>
        </div>
    )
}

const ContactShow = (props) => {
    const toRedirect = useRefresh();

    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Contact</h3>
            <Show title=" " actions={<ContactShowActions />} {...props}>
                <SimpleShowLayout>
                    <ContactShowGeneral className="mb-3" record={{ ...props }} />
                    <LocationSectionTitle record={{ ...props }} />
                    <ReferenceManyField
                        addLabel={false}
                        reference="locations"
                        target="contact_id"
                        source="id"
                        sort={{ field: 'name', order: 'DESC' }}
                        display="flex" flex="0 0 100%" flexWrap="wrap"
                        pagination={<Pagination />}
                        perPage={10}
                        emptyText="Nothing to show"
                    >
                        <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                            <TextField source="name" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                            <TextField source="status" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} />
                            <TextField source="address.street" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Street </h6>} />
                            <TextField source="address.city" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>City </h6>} />
                            <TextField source="address.state" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>State </h6>} />
                            <TextField source="address.zip" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Zip </h6>} />
                        </Datagrid>
                    </ReferenceManyField>
                </SimpleShowLayout>
            </Show>
        </>
    )
};


export default ContactShow;
